import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=d36742f8&scoped=true"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"
import style0 from "./ticket.vue?vue&type=style&index=0&id=d36742f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36742f8",
  null
  
)

export default component.exports